import { useEffect, useState } from 'react';

const useResponsiveCheck = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isBelow768, setIsBelow768] = useState(false);

  const width = window.innerWidth;
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(width <= 575);
      setIsTablet(width >= 769 && width <= 1130);
      setIsBelow768(width < 768); // new
    };

    checkScreenSize(); // initial run

    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, [width]);

  return { isMobile, isTablet, isBelow768 };
};

export default useResponsiveCheck;
